import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  rootAddFlights: {},
  addFlights: {
    '& p': {
      '& span:first-child': { fontWeight: 'bold' },
    },
  },
  hero: {
    padding: 0,
    position: 'relative',
    borderRadius: '4px',
  },
  firstText: {
    order: '-1',
    fontSize: `${theme.typography.pxToRem(16)}!important`,
    lineHeight: 'normal!important',
    alignSelf: 'flex-start',
    textTransform: 'uppercase',
    fontFamily: `${theme.typography.proxima.regular}!important`,
    marginBottom: '4px!important',
    [theme.breakpoints.only('xl')]: {
      fontSize: `${theme.typography.pxToRem(18)}!important`,
    },
  },
  addFlightsMedia: {
    height: 'auto',
    '& div:nth-of-type(2)': {
      padding: '24px',

      [theme.breakpoints.up('md')]: {
        width: '77%',
        alignSelf: 'start',
      },
      [theme.breakpoints.only('lg')]: {
        width: '85%',
        alignSelf: 'start',
      },
      [theme.breakpoints.only('xl')]: {
        width: '60%',
      },
    },

    '& h1:nth-of-type(1)': {
      fontSize: theme.typography.pxToRem(20),
      alignSelf: 'flex-start',
      fontFamily: theme.typography.kapra.regular,
      fontWeight: '700',
      letterSpacing: '1px',
      [theme.breakpoints.only('md')]: {
        fontSize: theme.typography.pxToRem(34),
      },
      [theme.breakpoints.only('lg')]: {
        fontSize: theme.typography.pxToRem(30),
      },
      [theme.breakpoints.only('xl')]: {
        fontSize: theme.typography.pxToRem(38),
      },
    },

    '& p:nth-of-type(1)': {
      fontSize: theme.typography.pxToRem(16),
      textAlign: 'initial',
      fontFamily: theme.typography.proxima.semiBold,
      margin: '16px 0px',
      lineHeight: '120%',
      [theme.breakpoints.only('xl')]: {
        paddingRight: '10px',
      },
    },

    '& button:nth-of-type(1)': {
      width: '100%',
      borderRadius: '4px',
      fontSize: theme.typography.pxToRem(14),
      fontWeight: '600',
      margin: 0,
      textTransform: 'none',
      backgroundColor: theme.palette.white,
      color: theme.palette.blue2,
      border: `1px solid ${theme.palette.blue2}`,
      padding: '11.5px 30px',
      [theme.breakpoints.up('md')]: {
        width: 'unset',
        alignSelf: 'start',
      },
      '&:hover': {
        backgroundColor: theme.palette.blue4,
      },
    },
    '& img': {
      objectFit: 'cover',
      objectPosition: 'top',
    },
  },
  filterMedia: { opacity: '0' },
  gradientOverlay: {
    background: `linear-gradient(88deg, rgba(6, 21, 86, 0.80) 8.56%, rgba(0, 0, 0, 0.00) 132.72%)`,
    [theme.breakpoints.up('md')]: {
      background: ` linear-gradient(90deg, rgba(6, 21, 86, 0.80) 7.03%, rgba(0, 0, 0, 0.00) 84.16%)`,
    },
    content: "''",
    height: '100%',
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    pointerEvents: 'none',
    borderRadius: '5px',
  },
}));

export default useStyles;
